import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import classes from "./ExperienceExcellence.module.css";

function ExperienceCarousel({data}) {
  const swiperRef = useRef(null); // Create a ref to control the Swiper instance


  return (
    <div className="experience-carousel">
      <div style={{ position: "relative", width: "100%", margin: "auto" }}>
        {/* Swiper */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay]} // Enable navigation and pagination
          autoplay={{
            delay: 3000, // 3 seconds
            disableOnInteraction: false, // Autoplay continues even after interaction
          }}
          slidesPerView={1} // Show 3 images at a time
          spaceBetween={20} // Add space between slides
          onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
          pagination={{ clickable: true }} // Enable clickable dots
          loop={true} // Enable infinite looping
          draggable={true} // Enable drag/swipe functionality
          className="exp-carousel"
        >
          {data?.listingItems[0]?.images?.map((slide) => (
            <SwiperSlide key={slide.id}>
              <img
                src={slide.url}
                alt={slide?.imageTag}
                className={classes.experienceImage}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ExperienceCarousel;
